// ScreenHelp — the one "About this screen" affordance.
//
// Operator, 7 Sept 2026: "look at the clutter… make it clean, organised,
// minimalist." Every screen now keeps a ONE-sentence subtitle under its title;
// the paragraph that used to sit there lives here, closed by default, and
// opens on a tap. One component, so every screen's help reads and behaves the
// same way — no screen grows its own variant.
//
// It renders two siblings straight into the PARENT's flex row (display:
// contents): the small toggle, which takes its place at the right of the title
// row, and the expanded text, which wraps onto a full-width line beneath it.
// ScreenHeader is the layout that expects this; anywhere else, put it inside
// a `flex flex-wrap` box and it behaves the same way.

import { useState } from 'react';
import type { ReactNode } from 'react';
import { ChevronDown, Info } from 'lucide-react';

export function ScreenHelp({ children, label = 'About this screen' }: {
  children: ReactNode;
  label?: string;
}) {
  const [open, setOpen] = useState(false);
  return (
    <div className="contents">
      <button
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        className="tap-44 order-2 lg:order-4 ml-auto inline-flex shrink-0 items-center gap-1 self-start rounded px-1.5 py-1 text-meta text-tg-hint transition-colors hover:text-tg-text"
      >
        <Info size={12} className="opacity-80" />
        <span>{label}</span>
        <ChevronDown size={11} className={`transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="order-5 lg:order-6 basis-full mt-2 space-y-2 rounded-lg border border-stroke-soft bg-panel-2/50 px-3 py-2.5 text-meta leading-[1.55] text-tg-hint">
          {children}
        </div>
      )}
    </div>
  );
}
